import { ImportCostCenterService } from "./ImportCostCenterService";

export const importCostService = new ImportCostCenterService();
